module.exports = __webpack_public_path__ + "media/dashboard/assets/images/audit_log_icons/system_config-e80e5c1ea6410e3f3d1955efd3f8bbf6.svg";